import { inject } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { Grid } from 'common/lazy';
import { useClassName } from 'common/hooks';
import { DesktopOnly, MobileOnly } from 'common/components';
import Deal from 'public/screens/Deals/components/Deal';

import useCustomStyle from '../../hooks';
import Center from '../Center';

import './retail-deals.less';

const MAX_DEALS = 3;

export default inject('deals')(function RetailDeals({ deals, component }) {
  const classNames = useClassName('CLPRetailDeals');
  const [items, setItems] = useState([]);
  const [setRef, style] = useCustomStyle(component.fields.settings);

  const title = style['--title'];

  useEffect(() => {
    deals.getRetailDeals({ limit: MAX_DEALS }).then((data) => {
      setItems(Array.isArray(data) ? data : []);
    });
  }, []);

  if (!items.length) return null;

  const renderDeals = (columns) => (
    <Grid columns={columns} style={{ gap: '16px' }}>
      {items.map((deal) => (
        <Deal deal={deal} variation="retail" key={deal.id} />
      ))}
    </Grid>
  );

  return (
    <Center className={classNames('container')} ref={setRef}>
      {title && <div className={classNames('title')}>{title}</div>}
      <DesktopOnly>{renderDeals(3)}</DesktopOnly>
      <MobileOnly>{renderDeals(1)}</MobileOnly>
    </Center>
  );
});
